import map from 'lodash/map';
import { filter } from 'lodash';
import { useMemo } from 'react';

import useResource, { getConsolidatedState, isLoadingStatus, useResourceAll } from 'src/presentation/hooks/useResource';
import endpointsResource from 'src/actions/endpoints/endpointsResource';
import accountsResource from 'src/actions/accounts/accountsResource';
import { SenderStatus } from 'src/models/Channels/WhatsAppSender';

export default function useExistingWhatsAppSenders() {
  const { values: endpoints = [], loadingState: endpointsLoadingState } = useResourceAll(endpointsResource);
  const { values: accounts = [], loadingState: accountsLoadingState } = useResource(accountsResource, {
    fetch: true,
  });

  const accountToWabaIdMap = useMemo(
    () =>
      accounts
        .filter(account => account.type === 'TWILIO_MESSAGING')
        .reduce(
          (
            acc,
            account: {
              id: string;
              content: {
                wabaId: string;
              };
            }
          ) => {
            acc[account.id] = account.content.wabaId;
            return acc;
          },
          {}
        ),
    [accounts]
  );

  const whatsAppSenders = useMemo(
    () =>
      map(
        filter(endpoints, endpoint => endpoint.type === 'WHATSAPP'),
        sender => ({
          id: sender.id, // endpoint id
          createdAt: sender.createdAt,
          phoneNumber: sender.address,
          displayName: sender.configuration?.displayName,
          sid: sender.configuration?.sid,
          status: sender.configuration?.status?.toLowerCase() === 'online' ? SenderStatus.ONLINE : SenderStatus.PENDING,
          wabaId: accountToWabaIdMap[sender.accountId],
        })
      ),
    [endpoints, accountToWabaIdMap]
  );

  const loadingState = getConsolidatedState([endpointsLoadingState, accountsLoadingState]);

  return {
    isLoading: isLoadingStatus(loadingState),
    whatsAppSenders,
  };
}
